class MM4GM_Map {
  constructor( {
    apiKey,
    mapWrapper = document.getElementById( 'mm4gm-map-wrapper' ),
    mapContainer = document.getElementById( 'mm4gm-map-canvas' ),
    catBtnContainer = document.getElementById( 'mm4gm-cat-nav' ),
    listContainer = document.getElementById( 'mm4gm-landmark-list' ),
    directionsContainer = document.getElementById( 'mm4gm-directions' ),
    mapOptions: {
      centerLat = 39.130107,
      centerLng = -76.792481,
      zoom = 15,
      mapTypeControl = false,
      streetViewControl = false,
      zoomControl = false,
      rotateControl = false,
      scaleControl = false,
      fullscreenControl = false,
      gestureHandling = '',
      customMapStyles,
    } = {},
    markerOptions: {
      addCenterMarker = true,
      addMarkers = false,
      customCatMarkers = false,
      centerMarkerImg,
      centerMarkerHeight = 60,
      centerMarkerWidth = 60,
      centerMarkerInfoWindowContent,
      markersEndpoint,
      addLandmarkListing = false,
      markersInitialView = true,
    } = {},
    categoryOptions: {
      addCategoryNav = false,
      categoryIconCount = '',
      categoriesEndpoint,
    } = {},
    directionsOptions: {
      addDirections = false,
      endingAddress = null,
      showFieldLabels = true,
      startFieldLabel = null,
      startFieldPlaceholder = null,
      buttonText = null,
    } = {},
    resetOptions: {
      addResetButton = false,
      resetButtonText = 'Reset Map',
    } = {},
    locations = [],
    markers = [],
    mapBounds = false,
    bounds = null,
    infoWindow = null,
    directionsService = null,
    directionsDisplay = null,
    resetBtn,
    customMarkers = null,
  } = {} ) {
    // eslint-disable-next-line no-unused-expressions
    ( this.apiKey = apiKey ),
    ( this.mapWrapper = mapWrapper ),
    ( this.mapContainer = mapContainer ),
    ( this.catBtnContainer = catBtnContainer ),
    ( this.listContainer = listContainer ),
    ( this.directionsContainer = directionsContainer ),
    ( this.mapOptions = {
      centerLat,
      centerLng,
      zoom,
      mapTypeControl,
      streetViewControl,
      zoomControl,
      rotateControl,
      scaleControl,
      fullscreenControl,
      gestureHandling,
      customMapStyles,
    } ),
    ( this.markerOptions = {
      addCenterMarker,
      addMarkers,
      customCatMarkers,
      centerMarkerImg,
      centerMarkerWidth,
      centerMarkerHeight,
      centerMarkerInfoWindowContent,
      markersEndpoint,
      addLandmarkListing,
      markersInitialView,
    } ),
    ( this.categoryOptions = {
      addCategoryNav,
      categoryIconCount,
      categoriesEndpoint,
    } ),
    ( this.directionsOptions = {
      addDirections,
      endingAddress,
      showFieldLabels,
      startFieldLabel,
      startFieldPlaceholder,
      buttonText,
    } ),
    ( this.resetOptions = {
      addResetButton,
      resetButtonText,
    } ),
    ( this.locations = locations ),
    ( this.markers = markers ),
    ( this.mapBounds = mapBounds ),
    ( this.bounds = bounds ),
    ( this.infoWindow = infoWindow ),
    ( this.directionsService = directionsService ),
    ( this.directionsDisplay = directionsDisplay ),
    ( this.resetBtn = resetBtn );
    this.customMarkers = customMarkers;
  }

  init() {
    document.addEventListener( 'DOMContentLoaded', () => {
      if ( this.mapWrapper && this.mapContainer && this.apiKey ) {
        let lang;
        // eslint-disable-next-line no-unused-expressions
        document.querySelector( 'html' ).lang ?
          ( lang = document.querySelector( 'html' ).lang ) :
          ( lang = 'en' );

        const mapJsFile = document.createElement( 'script' );
        mapJsFile.type = 'text/javascript';
        mapJsFile.src = `https://maps.googleapis.com/maps/api/js?key=${ this.apiKey }&callback=buildMap&language=${ lang }`;
        document.querySelector( 'body' ).appendChild( mapJsFile );
      } else if ( ! this.mapWrapper ) {
        console.error( 'Map wrapper DOM element not found.' );
      } else if ( ! this.mapContainer ) {
        console.error( 'Map container DOM element not found.' );
      } else if ( ! this.apiKey ) {
        console.error( 'API key not found.' );
      }
    } );

    window.buildMap = this.buildMap.bind( this );
  }

  buildMap() {
    const mapStyles = this.mapOptions.customMapStyles ?
      this.mapOptions.customMapStyles :
      null;

    const map = new google.maps.Map( this.mapContainer, {
      center: {
        lat: this.mapOptions.centerLat,
        lng: this.mapOptions.centerLng,
      },
      zoom: this.mapOptions.zoom,
      mapTypeControl: this.mapOptions.mapTypeControl,
      streetViewControl: this.mapOptions.streetViewControl,
      zoomControl: this.mapOptions.zoomControl,
      rotateControl: this.mapOptions.rotateControl,
      scaleContol: this.mapOptions.scaleControl,
      fullscreenControl: this.mapOptions.fullscreenControl,
      gestureHandling: this.mapOptions.gestureHandling,
      styles: mapStyles,

      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
    } );

    this.infoWindow = new google.maps.InfoWindow();
    this.directionsService = new google.maps.DirectionsService();
    this.directionsDisplay = new google.maps.DirectionsRenderer();
    this.directionsDisplay.setMap( map );

    if ( this.markerOptions.addCenterMarker ) {
      this.addCenterMarker( map );
    }

    if ( this.markerOptions.addMarkers ) {
      if ( ! this.markerOptions.markersEndpoint ) {
        console.error( 'You must enter an endpoint to your marker data.' );
      } else {
        this.fetchMarkerData( map );
      }
    }

    if ( this.categoryOptions.addCategoryNav ) {
      if ( ! this.categoryOptions.categoriesEndpoint ) {
        console.error( 'You must enter an endpoint to your category data.' );
      } else if ( ! this.markerOptions.addMarkers ) {
        console.error( 'You should have categorized markers enabled.' );
      } else {
        this.fetchCategoryData( map );
      }
    }

    if ( this.directionsOptions.addDirections ) {
      this.createDirectionsForm( map );
    }

    if ( this.resetOptions.addResetButton ) {
      this.createResetBtn( map );
    }
  }

  addCenterMarker( map ) {
    let centerMarkerIcon = null;
    if ( this.markerOptions.centerMarkerImg ) {
      centerMarkerIcon = {
        url: this.markerOptions.centerMarkerImg,
        scaledSize: new google.maps.Size(
          this.markerOptions.centerMarkerWidth,
          this.markerOptions.centerMarkerHeight
        ), // scaled size
        origin: new google.maps.Point( 0, 0 ), // origin
        anchor: new google.maps.Point(
          this.markerOptions.centerMarkerWidth * 0.5,
          this.markerOptions.centerMarkerHeight * 0.5
        ), // anchor
      };
    }

    const centerMarkerText = this.markerOptions.centerMarkerInfoWindowContent ?
      this.markerOptions.centerMarkerInfoWindowContent :
      null;

    const centerMarker = new google.maps.Marker( {
      position: {
        lat: this.mapOptions.centerLat,
        lng: this.mapOptions.centerLng,
      },
      map,
      zIndex: 1000,
      icon: centerMarkerIcon,
      html: centerMarkerText,
    } );

    if ( this.markerOptions.centerMarkerInfoWindowContent ) {
      centerMarker.addListener( 'click', () => {
        if ( this.infoWindow != null ) {
          this.infoWindow.close();
        }

        this.infoWindow.setContent( centerMarker.html );
        this.infoWindow.open( map, centerMarker );
      } );
    }
  }

  fetchMarkerData( map ) {
    fetch( this.markerOptions.markersEndpoint )
      .then( ( resp ) =>
        this.fetchAllMarkers(
          map,
          Number( resp.headers.get( 'x-wp-total' ) ),
          Number( resp.headers.get( 'x-wp-totalpages' ) )
        )
      )
      .catch( ( err ) => console.error( err ) );
  }

  fetchAllMarkers( map, totalCount, pages ) {
    const markers = [];
    for ( let i = 1; i <= pages; i++ ) {
      fetch( this.markerOptions.markersEndpoint + '&page=' + i )
        .then( ( blob ) => blob.json() )
        .then( ( data ) => {
          markers.push( ...data );
          if ( markers.length === totalCount ) {
            this.addMarkers( map, markers );
          }
        } );
    }
  }

  addMarkers( map, data ) {
    if ( this.mapBounds ) {
      this.bounds = new google.maps.LatLngBounds();
    }
    let triggerWrapperUl;
    if (
      this.markerOptions.addLandmarkListing &&
      this.categoryOptions.addCategoryNav
    ) {
      const triggerWrapperHeader = document.createElement( 'h2' );
      triggerWrapperUl = document.createElement( 'ul' );
      this.listContainer.appendChild( triggerWrapperHeader );
      this.listContainer.appendChild( triggerWrapperUl );
    }

    data.forEach( ( item, index ) => {
      let title = item.title.rendered;
      let alpha;
      let add =
        item.cmb2.mm4_google_map_landmark_meta.mm4_google_map_landmark_add_1;
      let add2 =
        item.cmb2.mm4_google_map_landmark_meta.mm4_google_map_landmark_add_2;
      let phone =
        item.cmb2.mm4_google_map_landmark_meta.mm4_google_map_landmark_phone;
      let website =
        item.cmb2.mm4_google_map_landmark_meta.mm4_google_map_landmark_website;
      let details =
        item.cmb2.mm4_google_map_landmark_meta.mm4_google_map_landmark_details;
      const latitude = parseFloat(
        item.cmb2.mm4_google_map_landmark_meta.mm4_google_map_landmark_lat
      );
      const longitude = parseFloat(
        item.cmb2.mm4_google_map_landmark_meta.mm4_google_map_landmark_lng
      );
      const category = 'cat-' + item.mm4_gm_landmark_types[ 0 ];

      if ( title !== '' ) {
        alpha = title;
        title = '<strong class="info-window-heading">' + title + '</strong>';
      } else {
        alpha = '';
        title = '';
      }

      if ( add !== '' ) {
        add = '<br>' + add;
      } else {
        add = '';
      }

      if ( add2 !== '' ) {
        add2 = '<br>' + add2;
      } else {
        add2 = '';
      }

      if ( phone !== '' ) {
        phone = '<br>' + phone;
      } else {
        phone = '';
      }

      if ( website !== '' ) {
        website =
          '<br><a target="_blank" href="' + website + '">Website &raquo;</a>';
      } else {
        website = '';
      }

      if ( details !== '' ) {
        details = '<br><br>' + details;
      } else {
        details = '';
      }

      this.locations.push( {
        index,
        title,
        latitude,
        longitude,
        add,
        add2,
        phone,
        website,
        details,
        category,
        alpha,
      } );
    } );

    this.locations.sort( ( a, b ) => ( a.alpha > b.alpha ? 1 : -1 ) );

    let icon = {
      origin: new google.maps.Point( 0, 0 ), // origin
    };

    this.locations.forEach( ( item ) => {
      if ( this.markerOptions.customCatMarkers && this.customMarkers ) {
        if ( Object.keys( this.customMarkers ).length > 0 && Object.keys( this.customMarkers )[ 0 ] !== '' ) {
          const cat = Number( item.category.replace( 'cat-', '' ) );
          if ( Number.isInteger( cat ) ) {
            icon.url = this.customMarkers[ cat ].markerImg;
            if ( icon.url ) {
              icon.scaledSize = new google.maps.Size(
                this.customMarkers[ cat ].markerImgWidth,
                this.customMarkers[ cat ].markerImgHeight
              );
              icon.anchor = new google.maps.Point(
                this.customMarkers[ cat ].markerImgWidth * .5,
                this.customMarkers[ cat ].markerImgHeight * .5
              );
            }
          }
        } else {
          icon = null;
        }
      } else {
        icon = null;
      }

      const marker = new google.maps.Marker( {
        position: {
          lat: item.latitude,
          lng: item.longitude,
        },
        map,
        icon,
        visible: this.markerOptions.markersInitialView ? true : false,
        html: `${ item.title }
          ${ item.add }
          ${ item.add2 }
          ${ item.phone }
          ${ item.website }
          ${ item.details }`,
      } );

      if ( this.mapBounds ) {
        this.bounds.extend( marker.getPosition() );
      }

      if (
        this.markerOptions.addLandmarkListing &&
        this.categoryOptions.addCategoryNav
      ) {
        const listItem = document.createElement( 'li' );
        const btn = document.createElement( 'button' );
        const title = item.title;
        listItem.classList.add( item.category );
        listItem.classList.add( 'marker-trigger' );
        btn.innerHTML = title;
        listItem.appendChild( btn );
        triggerWrapperUl.appendChild( listItem );

        google.maps.event.addDomListener( btn, 'click', function() {
          google.maps.event.trigger( marker, 'click' );
        } );
      }

      this.markers.push( marker );
      this.openInfoWindow( marker, map );
    } );

    if ( this.mapBounds ) {
      map.fitBounds( this.bounds );
    }
  }

  openInfoWindow( marker, map ) {
    marker.addListener( 'click', () => {
      if ( this.infoWindow != null ) {
        this.infoWindow.close();
      }

      this.infoWindow.setContent( marker.html );
      this.infoWindow.open( map, marker );
    } );
  }

  fetchCategoryData( map ) {
    fetch( this.categoryOptions.categoriesEndpoint )
      .then( ( data ) => data.json() )
      .then( ( data ) => this.addCategoryNav( map, data ) )
      .catch( ( err ) => console.error( err ) );
  }

  addCategoryNav( map, data ) {
    const catNavUl = document.createElement( 'ul' );
    this.catBtnContainer.appendChild( catNavUl );

    data.forEach( ( item ) => {
      if ( item.count > 0 ) {
        const listItem = document.createElement( 'li' );
        const listItemBtn = document.createElement( 'button' );
        listItemBtn.id = 'cat-' + item.id;
        listItemBtn.classList.add( item.slug, 'cat-toggle' );

        // TODO: Add aria controls and empty alt tags
        if ( this.categoryOptions.categoryIconCount === 'count' ) {
          listItemBtn.innerHTML = `<span class="count">${ item.count }</span> <span class="btn-name">${ item.name }</span>`;
        } else if ( this.categoryOptions.categoryIconCount === 'icon' ) {
          const cat = item.id;
          listItemBtn.innerHTML = `<img class="icon" src="${ this.customMarkers[ cat ].navImg }"> <span class="btn-name">${ item.name }</span>`;
        } else {
          listItemBtn.innerHTML = `<span class="btn-name">${ item.name }</span>`;
        }

        listItem.appendChild( listItemBtn );
        catNavUl.appendChild( listItem );

        this.toggleCats(
          listItemBtn,
          this.locations,
          this.markers,
          this.infoWindow,
          this.resetBtn,
          map,
          this.markerOptions.addLandmarkListing
        );
      }
    } );

    document.querySelector( 'body' ).classList.add( 'has-map-cat-nav' );
  }

  toggleCats( btn, locations, markers, infoWindow, resetBtn, map, addList ) {
    const bounds = new google.maps.LatLngBounds();

    btn.addEventListener( 'click', function() {
      if ( infoWindow != null ) {
        infoWindow.close();
      }
      const cat = this.getAttribute( 'id' );

      locations.forEach( ( item, index ) => {
        if ( item.category === cat ) {
          markers[ index ].setVisible( true );
          bounds.extend( markers[ index ].getPosition() );
          markers[ index ].setOptions( { zIndex: 1100 } );
        } else if ( item.category !== cat ) {
          markers[ index ].setVisible( false );
        }
      } );

      map.fitBounds( bounds );

      if ( addList ) {
        const triggers = Array.from(
          document.querySelectorAll( '.marker-trigger' )
        );

        document.querySelector(
          '#mm4gm-landmark-list > h2'
        ).textContent = btn.querySelector( '.btn-name' ).textContent;
        document
          .querySelector( '#mm4gm-landmark-list > h2' )
          .classList.add( 'active' );

        triggers.forEach( ( trigger ) => {
          trigger.classList.remove( 'active' );
          if ( trigger.classList.contains( cat ) ) {
            trigger.classList.add( 'active' );
          }
        } );
      }

      const catToggleBtns = Array.from(
        document.querySelectorAll( '.cat-toggle' )
      );
      catToggleBtns.forEach( ( btn ) => {
        btn.classList.remove( 'active' );
      } );

      this.classList.add( 'active' );
      if ( resetBtn ) {
        resetBtn.classList.add( 'active' );
      }
    } );
  }

  createDirectionsForm( map ) {
    const endpoint = this.directionsOptions.endingAddress ?
      this.directionsOptions.endingAddress :
      `${ this.mapOptions.centerLat }, ${ this.mapOptions.centerLng }`;

    let label;
    if ( this.directionsOptions.showFieldLabels ) {
      label = this.directionsOptions.startFieldLabel;
    } else {
      label = `<span class="screen-reader-text">${ this.directionsOptions.startFieldLabel }</span>`;
    }

    const placeholder = this.directionsOptions.startFieldPlaceholder ?
      this.directionsOptions.startFieldPlaceholder :
      '';

    const btnTxt = this.directionsOptions.buttonText;

    const directionsForm = document.createElement( 'form' );
    directionsForm.id = 'get-directions';
    directionsForm.innerHTML = `
      <label for="start">${ label }<input id="start" type="text" placeholder="${ placeholder }"></label>
      <input id="end" value="${ endpoint }" type="hidden">
      <div id="map-response-panel"></div>
      <input value="${ btnTxt }" type="submit">
    `;

    this.directionsContainer.appendChild( directionsForm );

    directionsForm.addEventListener( 'submit', ( evt ) => {
      this.calcRoute( directionsForm, map );
      evt.preventDefault();
    } );

    document.querySelector( 'body' ).classList.add( 'has-map-directions' );
  }

  calcRoute( form, map ) {
    const start = form[ 0 ].value;
    const end = form[ 1 ].value;
    const responsePanel = form.children.namedItem( 'map-response-panel' );
    const request = {
      origin: start,
      destination: end,
      travelMode: 'DRIVING',
    };

    if ( start === '' ) {
      responsePanel.innerHTML = 'Please enter a starting address';
      responsePanel.classList.add( 'active' );
      responsePanel.classList.add( 'error' );
    } else {
      this.directionsDisplay.setPanel( responsePanel );
      this.directionsService.route( request, ( result, status ) => {
        responsePanel.classList.remove( 'error' );
        responsePanel.classList.remove( 'active' );
        if ( status === 'OK' ) {
          responsePanel.classList.add( 'active' );
          responsePanel.innerHTML = '';
          this.directionsDisplay.setDirections( result );
          this.directionsDisplay.setMap( map );
          if ( this.resetBtn ) {
            this.resetBtn.classList.add( 'active' );
          }
        } else {
          responsePanel.innerHTML = `We're sorry, but an error occurred: <span>${ status }</span>.<br>Please check your starting address and try again.`;
          responsePanel.classList.add( 'error' );
          responsePanel.classList.add( 'active' );
        }
      } );
    }
  }

  createResetBtn( map ) {
    this.resetBtn = document.createElement( 'button' );
    this.resetBtn.id = 'mm4gm-map-reset-btn';
    this.resetBtn.textContent = this.resetOptions.resetButtonText;
    this.mapWrapper.appendChild( this.resetBtn );

    window.resetMap = this.resetMap.bind( this );

    this.resetBtn.addEventListener( 'click', function() {
      resetMap( map, this );
    } );
  }

  resetMap( map, btn ) {
    // TODO: Double check to make sure all of these are working.
    // ✅
    this.markers.forEach( ( item ) => {
      const visiblility = this.markerOptions.markersInitialView ? true : false;
      item.setVisible( visiblility );
    } );

    // ✅
    if ( this.mapBounds ) {
      map.fitBounds( this.bounds );
    } else {
      map.setCenter( {
        lat: this.mapOptions.centerLat,
        lng: this.mapOptions.centerLng,
      } );
      map.setZoom( this.mapOptions.zoom );
    }

    // ✅
    this.infoWindow.close();

    // ✅
    const mapNavItems = document.querySelectorAll( '#mm4gm-cat-nav button' );
    mapNavItems.forEach( ( item ) => {
      item.classList.remove( 'active' );
    } );

    // ✅
    if (
      this.markerOptions.landmarkListing &&
      this.categoryOptions.addCategoryNav
    ) {
      const triggersHeader = document.querySelector(
        '#mm4gm-landmark-list > h2'
      );
      triggersHeader.classList.remove( 'active' );
      triggersHeader.textContent = '';

      const triggers = Array.from( document.querySelectorAll( '.marker-trigger' ) );
      triggers.forEach( ( trigger ) => {
        trigger.classList.remove( 'active' );
      } );
    }

    // ✅
    btn.classList.remove( 'active' );

    // ❓
    this.directionsDisplay.setMap( null );
    this.directionsDisplay.setPanel( null );
    if ( document.getElementById( 'map-response-panel' ) ) {
      document.getElementById( 'map-response-panel' ).innerHTML = '';
      document.getElementById( 'map-response-panel' ).classList.remove( 'error' );
      document.getElementById( 'map-response-panel' ).classList.remove( 'active' );
    }
  }
}
